import React from 'react';
import { motion } from 'framer-motion';
import { HeartCrackIcon, SproutIcon, BanIcon, AlertTriangleIcon, ActivityIcon, HistoryIcon } from 'lucide-react';
export function ProblemSection() {
  const problems = [{
    title: 'Recetas Perdidas',
    desc: 'Estamos olvidando los secretos de nuestras abuelas, reemplazando la sabiduría milenaria por comida rápida y sin alma.',
    image: 'https://cdn.magicpatterns.com/uploads/78WdT2tkVWqkTz44ccHG2t/1.webp'
  }, {
    title: 'Salud Deteriorada',
    desc: 'Vivir con inflamación, falta de energía y problemas digestivos que la medicina moderna no logra solucionar.',
    image: 'https://cdn.magicpatterns.com/uploads/cC1wMw8pnsTv9EMMRKYLMi/2.webp'
  }, {
    title: 'Químicos Invisibles',
    desc: 'No saber realmente qué estás comiendo ni cómo los conservantes están afectando tu equilibrio hormonal.',
    image: 'https://cdn.magicpatterns.com/uploads/cN1MVXHu31wpSrUSaG5yr7/3.webp'
  }, {
    title: 'Falta de Conexión',
    desc: 'Cocinar se volvió una tarea mecánica en lugar de un ritual de sanación y amor para tu familia.',
    image: 'https://cdn.magicpatterns.com/uploads/rAfijw5SmS4raHmbaK3zhC/4.webp'
  }, {
    title: 'Miedo a los Alimentos',
    desc: 'Estar confundida con tantas dietas de moda que solo te restringen en lugar de nutrirte de verdad.',
    image: 'https://cdn.magicpatterns.com/uploads/pSgRvoBADge43eMooAhwCi/5.webp'
  }];
  return <section id="problem" className="py-24 bg-transparent text-[#0f1711] relative z-10 overflow-hidden pt-[25px] pb-[25px]" data-id="element-243">
      <div className="absolute inset-0 z-0 pointer-events-none opacity-20 overflow-hidden" data-id="element-244">
        <div className="absolute top-10 left-10 w-96 h-96 bg-[#d4af37]/10 rounded-full blur-[120px]" data-id="element-245" />
        <div className="absolute bottom-20 right-20 w-80 h-80 bg-green-900/5 rounded-full blur-[100px]" data-id="element-246" />
      </div>

      <div className="max-w-6xl mx-auto px-4 relative z-10" data-id="element-247">
        <div className="text-center mb-16" data-id="element-248">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-6xl font-black mb-6 tracking-tight text-[#3e2723] uppercase" data-id="element-249">
            ¿TE SIENTES ASÍ?
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-xl text-[#3e2723]/80 max-w-2xl mx-auto font-medium font-serif italic" data-id="element-250">
            La alimentación moderna nos ha alejado de nuestra esencia. Es
            momento de volver a lo que realmente nos nutre.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-251">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="group p-0 border border-[#0f1711]/10 rounded-[2rem] bg-white shadow-sm overflow-hidden hover:shadow-md transition-all duration-300" data-id="element-252">
              <div className="relative overflow-hidden aspect-[4/3]" data-id="element-253">
                <img src={problem.image} alt={problem.title} className="w-full h-full object-cover block transition-transform duration-500" data-id="element-254" />
              </div>
              <div className="p-8" data-id="element-255">
                <h3 className="text-2xl font-black text-[#0f1711] mb-4 tracking-wide" data-id="element-256">
                  {problem.title}
                </h3>
                <p className="text-[#3e2723]/70 leading-relaxed text-base font-medium" data-id="element-257">
                  {problem.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}